// extracted by mini-css-extract-plugin
export default {"badge":"StatusBadge_badge__mRXmz","badge--xs":"StatusBadge_badge--xs__U1Jg8","leadingVisual":"StatusBadge_leadingVisual__m1hjZ"};